let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8AM1y")).then(() => parcelRequire('hgh2B'));